import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../user';

/**
 * The main security service provides access to basic functionality
 */
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  /**
   * Event which is triggered when the authenticated user changes
   */
  public onUserUpdated = new EventEmitter<User>();

  constructor() {
    (<any>window).authenticationService = this;
  }

  /**
   * Starts the login process allowing for a redirect to the currnet location
   */
  public login(redirectToDeepLink?: boolean, deepLink?: string): void {
    //Need to use the variable otherwise angular complains on build
    console.log(redirectToDeepLink, deepLink);
    throw new Error('Not Implemented');
  }

  public refreshSession(): Observable<any> {
    throw new Error('Not Implemented');
  }

  /**
   * Starts the logout process
   */
  public logout(): void {
    throw new Error('Not Implemented');
  }

  /**
   * Determines if the authenticated user has one of the listed roles
   * @param roles The roles to check
   * @returns True if the user has the role otherwise false
   */
  public isRoleAuthorized(roles: string[]): boolean {
    let authorized = false;
    const user = this.user;

    if (user) {
      authorized = user.isRoleAuthorized(roles);
    }

    return authorized;
  }

  /**
   * Determines if the authenticated user has one of the listed groups
   * @param roles The groups to check
   * @returns True if the user has the group otherwise false
   */
  public isGroupAuthorized(groups: string[]): boolean {
    let authorized = false;
    const user = this.user;

    if (user) {
      authorized = user.isGroupAuthorized(groups);
    }

    return authorized;
  }

  /**
   * Returns true if there is currently an authenticated user, otherwise false
   */
  public get isAuthenticated(): boolean {
    throw new Error('Not Implemented');
  }

  /**
   * Gets the currently authenticated user
   */
  public get user(): User {
    throw new Error('Not Implemented');
  }

  /**
   *  Determines if token is expired
   */
  public isTokenExpired(): boolean {
    throw new Error('Not Implemented');
  }
}
